import React, { useEffect, useState, useCallback } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { max } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../shared/components/SmallLoader';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';
import { getSubscribersByCategoryData, handleLoader } from '../../../redux/actions/SubscribersByCategoryAction';
import { months } from '../CompareMonth/helper';
import { setCurrencyFormat, findMonthsBetweenDates } from '../../../utils/helpers';
import { filterShowWiseWithoutCollection, sortType } from '../helper';
import SubscribersTable from './SubscribersTable';
import ViewSalesReportModal from '../SalesCategoryByDay/ViewSalesReportModal';

const SubscribersByCategory = ({ dispatch, rtl }) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  const currentYear = moment().format('YYYY');
  const preYear = moment().subtract(1, 'years').format('YYYY');
  const currentMonth = moment().format('MMM');
  const prevMonth = moment().subtract(6, 'months').format('MMM');

  const { subscribersData, salesChannelFilterData, isLoading } = useSelector(
    ({ SubscribersByCategoryReducer, marketPlaceReducer }) =>
    ({
      subscribersData: SubscribersByCategoryReducer.subscribersData,
      isLoading: SubscribersByCategoryReducer.isLoading,
      salesChannelFilterData: marketPlaceReducer.salesChannel,

    })
  );

  const [dataToShow, setDataToShow] = useState(subscribersData?.modal?.data?.[0]?.yearlySubscriptionByCatSku)
  const [isOpen, setIsOpen] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [currentlyShow, setCurrentlyShow] = useState(filterShowWiseWithoutCollection?.[0]);
  const [maxValueObj, setMaxValueObj] = useState({});
  const [month2, setMonth2] = useState({ year: currentYear, month: currentMonth });
  const [month1, setMonth1] = useState({ year: preYear, month: prevMonth });
  const [tempMonth2, setTempMonth2] = useState({ year: currentYear, month: currentMonth });
  const [tempMonth1, setTempMonth1] = useState({ year: preYear, month: prevMonth });
  const [date1, setDate1] = useState(`${month1?.year}-${month1?.month}`);
  const [date2, setDate2] = useState(`${month2?.year}-${month2?.month}`);
  const [selectedCountryOptions, setSelectedCountryOptions] = useState([]);

  const yearOptions = [];
  for (let year = 2016; year <= currentYear; year += 1) {
    yearOptions.push({ label: year, value: year })
  }

  const monthOptions = months.map(item => ({ label: item, value: item }));
  const maxValue = max(Object.values(maxValueObj)) || 0;

  const countryCodeOptions = [];

  // eslint-disable-next-line array-callback-return
  subscribersData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).map((data) => {
    data.filterData.forEach((element) => {
      countryCodeOptions.push({
        value: element.key === "SP" ? "ES" : element.key,
        label: element.longValue
      });
    });
  });

  const sortedCountryOptions = countryCodeOptions.sort((a, b) => a.label > b.label ? 1 : -1)

  const filterBasedOnFilter = (item) => {
    const filters = Object.keys(filterData);
    let flag = true
    // eslint-disable-next-line no-restricted-syntax
    for (const i of filters) {
      const filter = filterData[i];
      const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
      if (filtersArray?.length && !filtersArray.includes(item[i]?.toLowerCase())) {
        flag = false
      }
    }

    return flag
  }

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 10,
        style: { top: 120, fontWeight: "bold" },
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvTable');
    const dvChartF = document.getElementById('dvChartFilter');
    const dvChartV = document.getElementById('dvChartView');
    dvTb.style.display = "none";
    dvChartF.style.display = "none";
    dvChartV.style.display = "none";
    const element = container.current || document.body;

    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
      // margin: "2cm",
      // forcePageBreak: ".page-break",
      //   landscape: true,
      //  multiPage: true,
      fileName: `Subscribers By Category Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";
    dvChartF.style.display = "block";
    dvChartV.style.display = "block";
  }

  const handleApplyDate = () => {
    const startDate = `${tempMonth1?.year}-${tempMonth1?.month}`;
    const endDate = `${tempMonth2?.year}-${tempMonth2?.month}`

    const monthsBetween = findMonthsBetweenDates(startDate, endDate);
    //  if (monthsBetween?.length > 0 && monthsBetween?.length <= 12) {
    setDate1(`${tempMonth1?.year}-${tempMonth1?.month}`);
    setDate2(`${tempMonth2?.year}-${tempMonth2?.month}`);
    setMaxValueObj({})
    //  dispatch(handleLoader(true));
    // dispatch(getSubscribersByCategoryData({ from: tempMonth2?.year, to: tempMonth1?.year }));
    // } else {
    //     Notification.newInstance({}, (notification) => {
    //         notification.notice({
    //             content: 'Please select maximum one year data'
    //         });
    //     });
    // }
  }

  const handleYearMonthChange = ({ isFrom, field, value }) => {

    if (isFrom) {
      setTempMonth1({ ...tempMonth1, [field]: value?.value });
    } else {
      setTempMonth2({ ...tempMonth2, [field]: value?.value })
    }
  }

  const setMaxValue = useCallback((val) => {
    if (!maxValueObj[val]) {
      setMaxValueObj({ ...maxValueObj, [val]: Number(val) })
    }
  }, [maxValueObj])

  const getMonths = (start, end) =>
    Array.from({ length: end.diff(start, 'month') + 1 }).map((_, index) =>
      moment(start).add(index, 'month').format('MMM-YYYY'));

  const selectedFromMonth = month1.month;
  const selectedFromYear = month1.year;
  const selectedToMonth = month2.month;
  const selectedToYear = month2.year;

  const selectFromDate = selectedFromMonth + selectedFromYear;
  const selectToDate = selectedToMonth + selectedToYear;

  const selectedMonths = getMonths(moment(selectFromDate, 'MMMYYYY'), moment(selectToDate, 'MMMYYYY'))

  // eslint-disable-next-line react/prop-types
  const RenderYearAndMonth = ({ isFrom }) => (
    <Col sm="12" md="3">
      <Row className="justify-content-space-between">
        <Col md="5" sm="6">
          <div className="form__form-group mb-0">
            <span className="form__form-group-label">Year</span>
            <div className="form__form-group-field">
              <Select
                value={isFrom ? { value: tempMonth1?.year, label: tempMonth1?.year }
                  : { value: tempMonth2?.year, label: tempMonth2?.year }}
                options={yearOptions}
                clearable={false}
                placeholder="Select Year"
                className="select_filter-80"
                onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                classNamePrefix="react-select"
                name={isFrom ? 'from' : 'to'}
              />
            </div>

          </div>
        </Col>
        <Col md="5" sm="6">
          <div className="form__form-group mb-0">
            <span className="form__form-group-label">Month</span>
            <div className="form__form-group-field">
              <Select
                value={isFrom ? { value: tempMonth1?.month, label: tempMonth1?.month }
                  : { value: tempMonth2?.month, label: tempMonth2?.month }}
                options={monthOptions}
                clearable={false}
                placeholder="Select Month"
                className="select_filter-80"
                onChange={value => handleYearMonthChange({ isFrom, field: 'month', value })}
                classNamePrefix="react-select"
                name={isFrom ? 'fromMonth' : 'toMonth'}
              />
            </div>
          </div>
        </Col>
      </Row>
    </Col>
  );

  const changeFilter = (value) => {
    setCurrentlyShow(value)
  };

  const changeFilterForCountry = (value) => {
    setSelectedCountryOptions(value)
  };

  useEffect(() => {
    dispatch(handleLoader(true));

    dispatch(getSubscribersByCategoryData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataToShow(subscribersData?.modal?.data?.[0]?.yearlySubscriptionByCatSku);
  }, [subscribersData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData])

  // if (isLoading) {
  //   return (
  //     <Container className="dashboard">
  //       <Row>
  //         <Loading loading={isLoading} />{' '}
  //       </Row>
  //     </Container>
  //   );
  // }

  let dataToShowForDatesSelected = [];

  const monthsBetweenDates = findMonthsBetweenDates(date1, date2);
  for (let i = 0; i < monthsBetweenDates.length; i += 1) {
    const [year, month] = monthsBetweenDates?.[i]?.split('-');
    let monthWiseData = dataToShow?.[year]?.monthlySubscriptionByCatSku?.[month] ?? [];
    if (monthWiseData) {
      monthWiseData = monthWiseData.filter(item =>
        filterBasedOnFilter(item))?.map(item => ({
          ...item,
          salesMonth: month,
          salesYear: year
        }))
      dataToShowForDatesSelected = dataToShowForDatesSelected?.concat(monthWiseData);

    }
  }

  if (selectedCountryOptions?.length) {
    const selected = selectedCountryOptions?.reduce((acc, item) => {
      acc[item?.value] = item.value
      return acc
    }, {})
    dataToShowForDatesSelected = dataToShowForDatesSelected.filter(item => selected[item.country])
  }

  const viewReportButton = () => (
    <div className="view-report">
      <button
        type="button"
        className="view-report btn btn-primary btn-sm"
        onClick={() => setIsOpen(true)}
      >
        View Report
      </button>
    </div>
  );

  const allCategories = {}
  const currentDataByCategory = {};

  dataToShowForDatesSelected.forEach((item) => {
    if (item && currentDataByCategory[item?.[currentlyShow?.value]]) {
      currentDataByCategory[item?.[currentlyShow?.value]]?.push(item)
    } else if (item) {
      if (!item?.[currentlyShow?.value] || item?.[currentlyShow?.value] === 'null') {
        currentDataByCategory?.['N/A']?.push(item)
      } else {
        currentDataByCategory[item?.[currentlyShow?.value]] = [item]
      }
    }
  });

  const currentMonthCat = Object.keys(currentDataByCategory);
  const dataToPlot = [];
  const options = [];

  const reduceCallback = (acc, day) => {

    const curDate = day.startDate;
    if (acc[curDate]) {
      acc?.[curDate]?.push(day)
    } else {
      acc[curDate] = [day]
    }

    if (day && !allCategories[day?.[currentlyShow?.value]]) {
      if (!day?.[currentlyShow?.value] || day?.[currentlyShow?.value] === 'null') {
        allCategories['N/A'] = 'N/A';
      } else {
        allCategories[day?.[currentlyShow?.value]] = day?.[currentlyShow?.value]
      }
    }
    return acc
  }
  let allDate = [];
  for (let i = 0; i < currentMonthCat.length; i += 1) {
    const cat = currentMonthCat[i];
    const currentMonthData = currentDataByCategory?.[cat] ?? [];
    allDate = allDate?.concat(currentMonthData);
    const currentYearMonthDayWise = currentMonthData?.reduce(reduceCallback, {})
    const categoryWiseSubscriptionsTotal = Object.keys(currentYearMonthDayWise)?.sort((a, b) =>
      a?.toLowerCase() > b?.toLowerCase() ? 1 : -1).reduce((acc, date) => {
        const noOfSubscriptions = currentYearMonthDayWise[date]?.
          reduce((accum, item) => Number(Number(Number(accum) +
            Number(item.noOfSubscriptions)).toFixed(2)), 0);

        acc[date] = { totalSubscriptionsPerDate: noOfSubscriptions };
        return acc
      }, {})
    options.push({
      value: cat, label: cat
    })

    dataToPlot.push({
      title: cat,
      categoryWiseSubscriptionsTotal,
    })

  }
  let tableHaderData = [...new Set(allDate.map(item => item.startDate))]
  tableHaderData = tableHaderData?.sort((a, b) => a?.toLowerCase() > b?.toLowerCase() ? 1 : -1)
  const dataToShowForExcel = [];
  const tableHeader = [];
  dataToPlot?.forEach((dataValue, index) => {
    const subData = {}
    subData.title = dataValue?.title;
    if (index === 0) {
      tableHeader.push({
        Header: currentlyShow?.value,
        accessor: 'title',
        disableGlobalFilter: false,
        width: 150,
        sortType
      })
    }
    tableHaderData?.forEach((date) => {
      subData[date] = setCurrencyFormat(dataValue?.categoryWiseSubscriptionsTotal?.
      [date]?.totalSubscriptionsPerDate, false);
      if (index === 0) {
        tableHeader.push({
          Header: date,
          accessor: date,
          disableGlobalFilter: false,
          width: 120,
          sortType
        })
      }
    });
    dataToShowForExcel.push(subData)
  });

  return (
    <Container className="dashboard">
      <Row className="category-sales">
        <Col sm="12">
          <Card className="pb-3">
            <CardBody className="min-w-50 p-3">
              <div className="card__title mb-2">
                <h5 className="bold-text card__title-center">Subscribers By Category/SKU</h5>
              </div>
              <Row className="justify-content-space-between align-items-center">
                <Col sm="6" md="2">
                  <div className="form__form-group mb-0">
                    <span className="form__form-group-label">Show</span>
                    <div className="form__form-group-field">
                      <Select
                        value={currentlyShow}
                        options={filterShowWiseWithoutCollection}
                        clearable={false}
                        placeholder="Select "
                        className="select_filter-150"
                        onChange={value => changeFilter(value)}
                        classNamePrefix="react-select"
                      />
                    </div>

                  </div>
                </Col>
                <Col sm="6" md="2">
                  <div className="form__form-group mb-0">
                    <span className="form__form-group-label">Country</span>
                    <div className="form__form-group-field">
                      <Select
                        value={selectedCountryOptions}
                        options={sortedCountryOptions}
                        clearable={false}
                        placeholder="Select "
                        className="select_filter"
                        onChange={changeFilterForCountry}
                        classNamePrefix="react-select"
                        isMulti
                      />
                    </div>

                  </div>
                </Col>
                <Col sm="12" md="8">
                  <Row className="justify-content-right align-items-center ">
                    <RenderYearAndMonth isFrom />
                    <Col sm='1' className="filter-to-position">~</Col>
                    <RenderYearAndMonth />
                    <Col sm="1" className="p-0 filter-to-position">
                      <button className="btn btn-sm btn-primary
                                             apply-date-button"
                        type="button" onClick={handleApplyDate}>
                        Apply</button>
                    </Col>&nbsp;&nbsp;
                    <Col md="2">
                      <button className="btn btn-sm btn-primary
                                             apply-date-button" style={{ marginTop: 40, fontSize: 12 }} type="button"
                        title='Export to pdf' disabled={isLoading}
                        onClick={exportToPDF}>Export pdf</button></Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <div id="divToPrint" ref={container}>
        <Row className="show-categ-month-wise-sales">
          <Col xs="12">
            <Card className="pb-3 show-categ-daily-sales">
              <CardBody>
                {isLoading ? (
                  <>
                    <div
                      style={{ minHeight: '200px' }}
                      className="row align-items-center justify-content-center"
                    >
                      <SmallLoader loading={isLoading} />
                    </div>
                  </>) : (
                  <SubscribersTable
                    dataToShowForDatesSelected={dataToShowForDatesSelected}
                    month={selectedMonths}
                    categorisedBasedOn={currentlyShow?.value}
                    title={`Subscribers by category and ${currentlyShow?.label}`}
                    firstColumn={currentlyShow?.label}
                    currentlyShow={currentlyShow}
                    excelData={dataToShowForExcel}
                    excelDataHeader={tableHeader}
                  />)}
              </CardBody>
            </Card>

          </Col>
        </Row>
      </div>
      <ViewSalesReportModal
        modalData={dataToShowForExcel}
        isOpen={isOpen}
        handleModal={setIsOpen}
        tableHeaderData={tableHeader}
      />
    </Container>
  );
};

SubscribersByCategory.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
}

export default connect(state => ({
  rtl: state.rtl,
}))(SubscribersByCategory);